import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Bot } from 'lucide-react';
import { Switch } from './ui/switch';
import { Card, CardContent } from './ui/card';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });

export const AdminAIGlobalCard = ({ editors, onGlobalChange }) => {
  const [settings, setSettings] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    axios.get(`${API}/admin/ai-settings`, auth()).then(({ data }) => setSettings(data)).catch(() => {});
  }, [editors]);

  const toggle = async (enabled) => {
    const msg = enabled ? 'Ativar o assistente de IA para TODAS as editoras?' : 'Desativar o assistente de IA para TODAS as editoras?';
    if (!window.confirm(msg)) return;
    setSaving(true);
    try {
      const { data } = await axios.put(`${API}/admin/ai-settings`, { enabled }, auth());
      setSettings(data);
      onGlobalChange(enabled);
    } catch (e) {
      alert(e.response?.data?.detail || 'Erro ao salvar');
    } finally {
      setSaving(false);
    }
  };

  if (!settings) return null;
  const allOn = settings.total > 0 && settings.enabled_count === settings.total;
  return (
    <Card className="data-card" style={{ marginBottom: '1.5rem' }} data-testid="admin-ai-global-card">
      <CardContent style={{ display: 'flex', alignItems: 'center', gap: '1rem', padding: '1rem 1.25rem', flexWrap: 'wrap' }}>
        <Bot className="w-6 h-6" style={{ color: '#D4A017' }} />
        <div style={{ flex: 1, minWidth: '220px' }}>
          <p style={{ fontWeight: 600, margin: 0 }}>Assistente de IA nos livros (todas as editoras)</p>
          <p data-testid="admin-ai-global-status" style={{ fontSize: '0.85rem', color: '#718096', margin: 0 }}>
            Ativo em {settings.enabled_count} de {settings.total} editoras. Ajuste individual na coluna "IA" da tabela.
          </p>
        </div>
        <span style={{ fontSize: '0.85rem', color: '#718096' }}>{allOn ? 'Ligado para todas' : 'Ligar para todas'}</span>
        <Switch checked={allOn} disabled={saving} onCheckedChange={toggle} className="data-[state=checked]:bg-teal-500" data-testid="admin-ai-global-switch" />
      </CardContent>
    </Card>
  );
};

export const EditorAISwitch = ({ editor, onSaved, field = 'ai_enabled', path = 'ai', label = 'IA' }) => {
  const [saving, setSaving] = useState(false);
  const toggle = async (enabled) => {
    setSaving(true);
    try {
      await axios.put(`${API}/admin/editors/${editor.id}/${path}`, { enabled }, auth());
      onSaved(enabled);
    } catch (e) {
      alert(e.response?.data?.detail || 'Erro ao salvar');
    } finally {
      setSaving(false);
    }
  };
  return (
    <Switch
      checked={editor[field] !== false}
      className="data-[state=checked]:bg-teal-500"
      disabled={saving}
      onCheckedChange={toggle}
      title={editor[field] !== false ? `${label} ativo nesta editora` : `${label} desativado nesta editora`}
      data-testid={field === 'ai_enabled' ? `admin-editor-ai-switch-${editor.id}` : `admin-editor-${path}-switch-${editor.id}`}
    />
  );
};
